import { useAuth } from '../context/AuthContext';

export const usePermissions = () => {
  const { user } = useAuth();

  /**
   * Check if user has a specific permission.
   * @param {string} permission - e.g. 'users.create'
   */
  const hasPermission = (permission) => {
    if (!user || !user.all_permissions) return false;
    // Super admin always has permission
    if (user.roles_list?.includes('super_admin')) return true;
    if (user.all_permissions.includes(permission)) return true;
    if (permission === 'maintenance.reminders' || permission === 'maintenance.payments') {
      return user.all_permissions.includes('maintenance.update');
    }
    return false;
  };

  /**
   * Check if user has a specific role.
   * @param {string|string[]} role - e.g. 'admin' or ['admin', 'accountant']
   */
  const hasRole = (role) => {
    if (!user || !user.roles_list) return false;
    if (Array.isArray(role)) {
      return role.some(r => user.roles_list.includes(r));
    }
    return user.roles_list.includes(role);
  };

  /**
   * Check if user can access a module based on view permission.
   * @param {string} module - e.g. 'finance'
   */
  const canAccess = (module) => {
    return hasPermission(`${module}.view`);
  };

  return { hasPermission, hasRole, canAccess, roles: user?.roles_list || [], permissions: user?.all_permissions || [] };
};
